module.exports = __webpack_public_path__ + "static/media/check.9cfef0a8.png";